module.exports = __webpack_public_path__ + "static/checklist-50988cecd05cb979682abf2dadc6f24e.png";